import styled from 'styled-components';
import AppLayout from './AppLayout';
import { useLoading } from '@/hooks/redux';
import type { AppShellProps } from '@/types';

const ShellContainer = styled.div`
  min-height: 100vh;
  min-height: 100dvh; /* 动态视口高度 */
  background: ${({ theme }) => theme.colors.background.primary};
  position: relative;
  overflow: hidden;
`;

const LoadingOverlay = styled.div<{ $visible: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: ${({ theme }) => theme.colors.background.primary};
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: ${({ theme }) => theme.zIndex.modal};
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  visibility: ${({ $visible }) => ($visible ? 'visible' : 'hidden')};
  transition: all ${({ theme }) => theme.transitions.normal} ${({ theme }) => theme.easings.easeInOut};
`;

const LoadingSpinner = styled.div`
  width: 40px;
  height: 40px;
  border: 3px solid ${({ theme }) => theme.colors.fill.tertiary};
  border-top: 3px solid ${({ theme }) => theme.colors.primary};
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

const AppShell: React.FC<AppShellProps> = ({ children, loading: propLoading = false }) => {
  // 从Redux获取全局loading状态
  const globalLoading = useLoading();
  const loading = propLoading || globalLoading;

  return (
    <ShellContainer>
      <AppLayout>
        {children}
      </AppLayout>
      <LoadingOverlay $visible={loading}>
        <LoadingSpinner />
      </LoadingOverlay>
    </ShellContainer>
  );
};

export default AppShell;